import { React, useState } from "react";
import ReactPaginate from "react-paginate";
import axios from "axios";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";

function StudentTable(props) {
  const { students, selectedStudent, setStudent, userType, updateTable, setUpdateTable } = props;

  const handleDelete = (pid) => {
    if (confirm("Are you sure you would like to delete this student? In doing so, you will be deleting this student's applications.")) {
      const body = new FormData();
      body.append("pid", pid);
      axios.post("/student/deleteStudent", body).then((res) => {
        const data = res.data;
        if (data.success) {
          setUpdateTable(!updateTable);
        }
      });
    };
  };

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  const items = students.map((student, index) => (
    <div
      className={"StudentButton-container flex p-2 rounded-md border-2 drop-shadow-2xl mb-2" + (student.pid === selectedStudent.pid ? " border-brand-primary" : "")}
      key={index}
    >
      <div className="StudentButton-leftContainer w-full">
        <div
          className="StudentButton-innerContainer"
          onClick={() => setStudent(student)}
        >
          <div className="StudentButton-topContainer flex justify-between">
            <div className="StudentButton-yearType text-lg font-brand-primary flex">
              {student.academicYear} | CS {student.csType} |{" "}
              {student.graduationYear}
            </div>
          </div>
          <div className="StudentButton-title text-2xl font-bold font-brand-primary text-start flex">
            {student.firstName} {student.lastName}
          </div>
          <div className="StudentButton-pid text-lg font-brand-primary flex normal-case">
            PID: {student.pid}
          </div>
          <div className="StudentButton-email text-lg font-brand-primary flex normal-case">
            Email: {student.email}
          </div>
        </div>
      </div>
      <div className="StudentButton-rightContainer">
        {userType === "admin" && (
          <button className="flex" onClick={() => handleDelete(student.pid)}>
            <CloseIcon fontSize="large" className="fill-brand-primary" />
          </button>
        )}
      </div>
    </div>
  ));

  const itemsPerPage = 5;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  if (students.length === 0) {
    return <div className="StudentTable bg-white p-2 mr-4 rounded-xl">No students found.</div>;
  } else {
    return (
      <div className="StudentTable bg-white p-2 mr-4 rounded-xl" style={{ minHeight: "816px" }}>
        <ReactPaginate
          breakLabel="..."
          marginPagesDisplayed={0}
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          className="flex w-full justify-between mb-6 mt-4 [&>li>a]:py-4 [&>li>a]:px-6 [&>li>a]:border [&>li>a]:rounded-lg [&>li.selected>a]:border-brand-primary"
        />
        <div className="StudentTable-currentStudents flex-grow-0 overflow-y-auto">{currentItems}</div>
      </div>
    );
  }
}

StudentTable.propTypes = {
  students: PropTypes.arrayOf({
    pid: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    academicYear: PropTypes.string,
    csType: PropTypes.string,
    bio: PropTypes.string,
    gitHubURL: PropTypes.string,
    graduationYear: PropTypes.string,
    linkedInURL: PropTypes.string,
    resumeFileName: PropTypes.string,
    websiteURL: PropTypes.string,
    emailNotif: PropTypes.number,
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobType: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
  }),
  selectedStudent: PropTypes.shape({
    pid: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    academicYear: PropTypes.string,
    csType: PropTypes.string,
    bio: PropTypes.string,
    gitHubURL: PropTypes.string,
    graduationYear: PropTypes.string,
    linkedInURL: PropTypes.string,
    resumeFileName: PropTypes.string,
    websiteURL: PropTypes.string,
    emailNotif: PropTypes.number,
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobType: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
  }),
  setStudent: PropTypes.func,
  userType: PropTypes.string,
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
};

StudentTable.defaultProps = {
  students: [],
  selectedStudent: {},
  setStudent: () => { },
  userType: "",
  updateTable: false,
  setUpdateTable: () => { },
};

export default StudentTable;
